let counter = 0

export function generateTempId() {
  counter += 1
  return `tmp-${Date.now()}-${counter}`
}
